import { Icon } from '@platform/components';
import ContentPanel from './ContentPanel';
import FeatureItem from './FeatureItem';
import FeaturePanel from './FeaturePanel';
import { H2, Description } from './utils';
import cx from 'classix';

const SquareFeaturePanel = ({
  title,
  description,
  items,
  mobileImage,
  desktopImage,
  isNumeric,
  imageBgColor = 'white',
}: {
  title: string;
  description: string;
  items: { title: string; description: string }[];
  mobileImage: string;
  desktopImage: string;
  /** Awkward; this actually controls some spacing formatting around the image as well, as we have special case formatting
   * tweaks to make for the /professionals' page's version of this component */
  imageBgColor?: 'white' | 'light-gray';
  /** This is clumsily named; it determines which variant of htis panel we render.
   * The 'numeric' version has feature items with blue circles and numbers, while the
   * non-numeric version shows yello accent circles with the light-bulb icon.
   *
   * At desktop resolutions, the non-numeric version places the graphic in the middle between two columns of
   * feature items, while the numeric version places the image on the right side. Both
   * versions use the same layout in mobile viewports.
   */
  isNumeric?: boolean;
}) => {
  return (
    <>
      <ContentPanel>
        <H2>{title}</H2>
        <Description>{description}</Description>
        <div className='relative'>
          <FeaturePanel>
            {items.map((item, index) => (
              <div key={index}>
                <FeatureItem
                  iconContent={
                    <div className='flex w-full h-full items-center justify-center text-2xl font-bold'>
                      <span>{isNumeric ? index + 1 : <Icon type='lightbulb-02' />}</span>
                    </div>
                  }
                  title={item.title}
                  description={item.description}
                  alignment='left'
                  color={isNumeric ? 'blue' : 'yellow'}
                />
              </div>
            ))}
          </FeaturePanel>
          <img
            className='hidden lg:block absolute right-[-120px] -top-36 w-1/2'
            src={desktopImage}
          />
        </div>
      </ContentPanel>
      <div className='contents lg:hidden'>
        <div
          className={cx(
            imageBgColor === 'light-gray' ? '-mt-3 py-6 bg-gray-50' : '-my-20 bg-white',
          )}
        >
          <div className='-mx-4'>
            <img className='w-full' src={mobileImage} />
          </div>
        </div>
      </div>
    </>
  );
};

export default SquareFeaturePanel;
